module.exports = __webpack_public_path__ + "img/symm.7726b8c4.png";